import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import DeleteIcon from '@mui/icons-material/Delete'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import ImageNotSupportedOutlinedIcon from '@mui/icons-material/ImageNotSupportedOutlined'
import LibraryAddOutlinedIcon from '@mui/icons-material/LibraryAddOutlined'
import {
    Collapse,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip,
} from '@mui/material'
import { DropPaper } from '../DropPaper'
import MainButton from '../../common/util/input/MainButton'
import InputField from '../../common/util/InputField'

export const AttributesTable = ({
    attributes,
    isLayerDuplicated,
    getDisplayedAttributeValueIndex,
    updateDisplayedAttributeValueIndex,
    getValuesAmountInAttribute,
    getChance,
    setChance,
    getChancePercentage,
    setSelectedAddValueAttribute,
    setSelectedEditValue,
    setSelectedBlockAttributesAttribute,
    setSelectedDeleteAttribute,
    setAddAttributeDialogOpened,
    updateLayers,
    setSelectedDisplayAllImagesAttribute,
}) => {
    return (
        <DropPaper noMargin className="2xl:my-auto my-10 overflow-x-auto">
            <Collapse in={attributes.length > 0}>
                <div className="overflow-x-auto">
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <b>Z-Index</b>
                                </TableCell>
                                <TableCell>
                                    <b>Name</b>
                                </TableCell>
                                <TableCell />
                                <TableCell align="center">
                                    <b>Value</b>
                                </TableCell>
                                <TableCell />
                                <TableCell></TableCell>
                                <TableCell>
                                    <b>Chance</b>
                                    <Tooltip
                                        title={
                                            <div className="text-base">
                                                By default every instance of an
                                                attribute has the same chance of
                                                being picked upon minting. Each
                                                instance gets a chance of 1,
                                                which represents an even
                                                distribution. You can adjust
                                                this value to affect the outcome
                                                (minimum 1, integers only). The
                                                absolute probability of this
                                                instance being picked is
                                                calculated and shown on the
                                                right as a percentage.
                                            </div>
                                        }
                                    >
                                        <IconButton
                                            size="small"
                                            color="primary"
                                        >
                                            <HelpOutlineOutlinedIcon />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {attributes.map((attribute, index) => (
                                <TableRow>
                                    {/* Z-Index */}
                                    <TableCell>
                                        {
                                            <div className="w-20">
                                                <InputField
                                                    variant="bordered"
                                                    fullWidth
                                                    type="number"
                                                    onWheel={(e) =>
                                                        e.target.blur()
                                                    }
                                                    value={
                                                        attribute
                                                            .possible_values[0]
                                                            .layers[0].layer
                                                    }
                                                    onChange={(e) => {
                                                        const newLayer =
                                                            e.target.value ===
                                                            ''
                                                                ? 0
                                                                : Math.min(
                                                                      Math.max(
                                                                          parseInt(
                                                                              e
                                                                                  .target
                                                                                  .value,
                                                                          ),
                                                                          0,
                                                                      ),
                                                                      255,
                                                                  )
                                                        updateLayers(
                                                            newLayer,
                                                            index,
                                                        )
                                                    }}
                                                    isInvalid={isLayerDuplicated(
                                                        attribute
                                                            .possible_values[0]
                                                            .layers[0].layer,
                                                    )}
                                                />
                                            </div>
                                        }
                                    </TableCell>
                                    {/* Name */}
                                    <TableCell>
                                        {attribute.attribute_name}
                                    </TableCell>
                                    {/* Prev */}
                                    <TableCell align="right">
                                        <IconButton
                                            color="primary"
                                            size="small"
                                            disabled={
                                                attribute.possible_values
                                                    .length === 0 ||
                                                getDisplayedAttributeValueIndex(
                                                    attribute.attribute_name,
                                                ) === 0
                                            }
                                            onClick={() =>
                                                updateDisplayedAttributeValueIndex(
                                                    attribute.attribute_name,
                                                    getDisplayedAttributeValueIndex(
                                                        attribute.attribute_name,
                                                    ) - 1,
                                                )
                                            }
                                        >
                                            <ArrowBackIosNewIcon />
                                        </IconButton>
                                    </TableCell>
                                    {/* Value */}
                                    <TableCell align="center">
                                        {attribute.possible_values.length >
                                        0 ? (
                                            <div
                                                className="text-primary font-bold hover:underline cursor-pointer"
                                                onClick={() => {
                                                    setSelectedAddValueAttribute(
                                                        attribute.attribute_name,
                                                    )
                                                    setSelectedEditValue(
                                                        attribute
                                                            .possible_values[
                                                            getDisplayedAttributeValueIndex(
                                                                attribute.attribute_name,
                                                            )
                                                        ].value,
                                                    )
                                                }}
                                            >
                                                {
                                                    attribute.possible_values[
                                                        getDisplayedAttributeValueIndex(
                                                            attribute.attribute_name,
                                                        )
                                                    ]?.value
                                                }
                                            </div>
                                        ) : (
                                            <span className="text-gray-300 italic">
                                                No Values
                                            </span>
                                        )}
                                    </TableCell>
                                    {/* Next */}
                                    <TableCell align="left">
                                        <IconButton
                                            size="small"
                                            color="primary"
                                            disabled={
                                                attribute.possible_values
                                                    .length === 0 ||
                                                getDisplayedAttributeValueIndex(
                                                    attribute.attribute_name,
                                                ) ===
                                                    getValuesAmountInAttribute(
                                                        attribute.attribute_name,
                                                    ) -
                                                        1
                                            }
                                            onClick={() =>
                                                updateDisplayedAttributeValueIndex(
                                                    attribute.attribute_name,
                                                    getDisplayedAttributeValueIndex(
                                                        attribute.attribute_name,
                                                    ) + 1,
                                                )
                                            }
                                        >
                                            <ArrowForwardIosIcon />
                                        </IconButton>
                                    </TableCell>
                                    {/* Current Value */}
                                    <TableCell align="left">
                                        <div className="whitespace-nowrap">
                                            {getDisplayedAttributeValueIndex(
                                                attribute.attribute_name,
                                            ) + 1}{' '}
                                            / {attribute.possible_values.length}
                                        </div>
                                    </TableCell>
                                    {/* Chance */}
                                    <TableCell>
                                        <div className="flex flex-wrap justify-start">
                                            <div className="w-24">
                                                <InputField
                                                    variant="bordered"
                                                    type="number"
                                                    onWheel={(e) =>
                                                        e.target.blur()
                                                    }
                                                    min={1}
                                                    isRequired={true}
                                                    isInvalid={
                                                        getChance(
                                                            attribute.attribute_name,
                                                            getDisplayedAttributeValueIndex(
                                                                attribute.attribute_name,
                                                            ),
                                                        ) === 0
                                                    }
                                                    onChange={(e) =>
                                                        setChance(
                                                            attribute.attribute_name,
                                                            getDisplayedAttributeValueIndex(
                                                                attribute.attribute_name,
                                                            ),
                                                            parseInt(
                                                                e.target.value,
                                                            ),
                                                        )
                                                    }
                                                    value={getChance(
                                                        attribute.attribute_name,
                                                        getDisplayedAttributeValueIndex(
                                                            attribute.attribute_name,
                                                        ),
                                                    )}
                                                    isDisabled={
                                                        getChance(
                                                            attribute.attribute_name,
                                                            getDisplayedAttributeValueIndex(
                                                                attribute.attribute_name,
                                                            ),
                                                        ) === null
                                                    }
                                                />
                                            </div>
                                            <div className="my-auto ml-3 font-mono">
                                                {getChancePercentage(
                                                    attribute.attribute_name,
                                                    getDisplayedAttributeValueIndex(
                                                        attribute.attribute_name,
                                                    ),
                                                )}
                                            </div>
                                        </div>
                                    </TableCell>
                                    <TableCell align="center">
                                        <IconButton
                                            color="primary"
                                            size="small"
                                            onClick={() => {
                                                setSelectedAddValueAttribute(
                                                    attribute.attribute_name,
                                                )
                                                setSelectedEditValue('')
                                            }}
                                        >
                                            <Tooltip title="Add Value...">
                                                <AddPhotoAlternateOutlinedIcon />
                                            </Tooltip>
                                        </IconButton>
                                    </TableCell>
                                    {/* Block Attributes... */}
                                    <TableCell align="center">
                                        <IconButton
                                            color="primary"
                                            size="small"
                                            onClick={() => {
                                                setSelectedBlockAttributesAttribute(
                                                    attribute.attribute_name,
                                                )
                                            }}
                                        >
                                            <Tooltip title="Block Attributes...">
                                                <ImageNotSupportedOutlinedIcon />
                                            </Tooltip>
                                        </IconButton>
                                    </TableCell>
                                    {/* Delete Attribute */}
                                    <TableCell align="center">
                                        <IconButton
                                            color="error"
                                            size="small"
                                            onClick={() =>
                                                setSelectedDeleteAttribute(
                                                    attribute.attribute_name,
                                                )
                                            }
                                        >
                                            <Tooltip
                                                title={
                                                    <div>
                                                        This deletes the{' '}
                                                        <b>
                                                            entire attribute
                                                            (the entire row)
                                                        </b>
                                                        . If you want to delete
                                                        an individual value
                                                        instead, click on the{' '}
                                                        <b>name</b> of the
                                                        value, and select{' '}
                                                        <b>DELETE VALUE</b> from
                                                        the Popup
                                                    </div>
                                                }
                                            >
                                                <DeleteIcon />
                                            </Tooltip>
                                        </IconButton>
                                    </TableCell>
                                    {/* Show all images Attribute */}
                                    <TableCell align="center">
                                        <IconButton
                                            color="primary"
                                            size="small"
                                            onClick={() => {
                                                setSelectedDisplayAllImagesAttribute(
                                                    index,
                                                )
                                            }}
                                        >
                                            <Tooltip
                                                title={
                                                    <div>
                                                        Show all images...
                                                    </div>
                                                }
                                            >
                                                <FormatListBulletedIcon />
                                            </Tooltip>
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </Collapse>
            <div className="flex flex-wrap justify-center mt-5 mb-2">
                <MainButton
                    className="w-40"
                    fullWidth
                    startContent={<LibraryAddOutlinedIcon />}
                    size="small"
                    onClick={() => setAddAttributeDialogOpened(true)}
                    disabled={
                        attributes.length > 0 &&
                        attributes[attributes.length - 1].possible_values[0]
                            .layers[0].layer === 255
                    }
                >
                    {' '}
                    Add Attribute
                </MainButton>
            </div>
        </DropPaper>
    )
}
